import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Discussion, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  discussion: Identifiable<Discussion>;
  currentPage: number;
  canLoadMore: boolean;
  retrieveDiscussion(
    request: Boundaries["retrieveDiscussion"]["request"],
  ): void;
}

function useRetrieveDiscussion(subject: string): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveDiscussionRequestPending(subject),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveDiscussionRequestSuccess(subject),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveDiscussionRequestFailure(subject),
    ),
    discussion: useSelector(() => selector.getDiscussion(subject)),
    currentPage: useSelector(() => selector.getDiscussionCurrentPage(subject)),
    canLoadMore: useSelector(() => selector.canLoadMoreDiscussion(subject)),
    retrieveDiscussion: core.retrieveDiscussion,
  };
}

export { useRetrieveDiscussion };
